export const formatPhoneNumber = (input: string) => {
  const regex = /(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/
  const formattedNumber = input.replace(regex, '$1.$2.$3.$4.$5')
  return formattedNumber
}